import Field from 'src/components/Common/InputContainer'
import React from 'react'
import { useTranslation } from 'react-i18next'

const StepThree: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Field
        required
        type="text"
        name="newPassword"
        component="input"
        preset="primary"
        label={t('forgot.stepThree.newPassword')}
      />
      <Field
        required
        type="text"
        name="newPasswordConfirmation"
        component="input"
        preset="primary"
        label={t('forgot.stepThree.confirmPassword')}
      />
    </>
  )
}

export default StepThree
